import {isNil} from 'ramda';

// Average glyph width relative to the font size, for runtimes without canvas text metrics.
const FALLBACK_GLYPH_WIDTH = 0.6;

/**
 * Width in pixels of the widest of the given one-line texts. Canvas text metrics match the SVG
 * text that Recharts draws. A runtime without `OffscreenCanvas`, such as jsdom, gets an estimate.
 */
export function measureWidestText(texts: string[], fontSize: number, fontFamily: string) {
  const context =
    typeof OffscreenCanvas === 'undefined' ? null : new OffscreenCanvas(1, 1).getContext('2d');

  const widths = texts.map((text) => {
    if (isNil(context)) {
      return text.length * fontSize * FALLBACK_GLYPH_WIDTH;
    }
    context.font = `${fontSize}px ${fontFamily}`;
    return context.measureText(text).width;
  });

  return Math.max(0, ...widths);
}
